module.exports = __webpack_public_path__ + "img/Skyscanner-new-Logo 2 copy.cda3f327.svg";